<template>
    <div id="topMostElement" class="providerSection">
        <div :style="`z-index: 1; position: absolute; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}; width: auto`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
                dismissible
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1>
            <v-icon
                v-if="screen_width > 520"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiFlaskEmpty }}
            </v-icon>
            Revalidate
            <v-btn
                v-if="isAcuApprovalValid && screen_width > 810"
                style="position: absolute; right: 6.5%; background-color: #009688; color: white;"
                class="ma-2"
                dark
                @click="handleGoBackBtn"
            >
                <v-icon
                    dark
                    left
                >
                    {{ mdiChevronLeft }}
                </v-icon>GO BACK
            </v-btn>
        </h1>
        <VerifyAcuApproval
            v-if="!isAcuApprovalValid"
            @isAcuApprovalValid="handleAcuApprovalResult"
        />
        <RevalidateForm
            v-else-if="acuData"
            :acu-data="acuData"
            :notif="notif"
            :is-revalidate-on-process="isRevalidateOnProcess"
            :validity-days="validityDays"
            @isAcuHasResult="handleAcuHasResult"
            @confirmRevalidate="handleConfirmRevalidate"
        />
        <RevalidateResult
            :show="showRevalidateResult"
            :acu-result="acuResult"
            :acu-data="acuData"
            @closeDialog="handleCloseDialog"
            @revalidateApproval="handleRevalidateApproval"
        />
    </div>
</template>

<script>
import VerifyAcuApproval from './VerifyAcuApproval.vue'
import RevalidateForm from './RevalidateForm.vue'
import RevalidateResult from './RevalidateResult.vue'
import {
    mdiFlaskEmpty,
    mdiChevronLeft
} from '@mdi/js'
export default {
    components: { VerifyAcuApproval, RevalidateForm, RevalidateResult },
    data: ()=>({
        mdiFlaskEmpty,
        mdiChevronLeft,
        validityDays: null,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        showRevalidateResult: false,
        acuResult: null,
        acuData: null,
        membInfo: null,
        isAcuHasResult: false,
        isAcuApprovalValid: false,
        isRevalidateOnProcess: false,
        valid: true,
        goToOptions: {
            duration: 500,
            offset: 0,
            easing: 'easeInOutCubic'
        },
        screen_width: document.documentElement.clientWidth + 9
    }),
    watch: {
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        }
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        handleCloseDialog() {
            this.isRevalidateOnProcess = false
            this.showRevalidateResult = false
            this.$store.commit('FETCH_ACU_APPROVAL', null)
            this.acuResult = null
        },
        handleConfirmRevalidate() {
            this.showRevalidateResult = true
        },
        handleRevalidateApproval(validityDays) {
            this.validityDays = validityDays
            this.isRevalidateOnProcess = true
        },
        handleGoBackBtn() {
            this.isAcuApprovalValid = false
        },
        handleAcuHasResult(newVal) {
            if (newVal && newVal.data && newVal.data[0]) {
                this.acuData = { membInfo: newVal.data[0], diagnostics: newVal.data }
            }
            this.acuResult = structuredClone(newVal)
        },
        handleAcuApprovalResult(newVal) {
            this.acuData = { membInfo: newVal.data[0], diagnostics: newVal.data }
            this.isAcuApprovalValid = true
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
</style>
